import { AxiosClient } from '_api/AxiosClient';
import { config } from '_config';

const { usersApiUrl } = config;

class AuthApi extends AxiosClient {
  constructor(url) {
    super(url);
    this.login = this.login.bind(this);
  }

  login({ username, password, category }) {
    const path = '/users/oauth2/token';
    this.Authorization = `Basic ${window.btoa(`%${category}%` + username + ':' + password)}`;
    return this.client.post(path, {});
  }
}

const ApiInstance = new AuthApi(usersApiUrl);

export { ApiInstance as AuthApi };
